import { ResourceExport } from '../../types/resource-export.type';
import PersonSellerList from './PersonSellerList';
import ScreenIcon from '@material-ui/icons/Tv';

const PersonSeller: ResourceExport = {
  list: PersonSellerList,
  icon: ScreenIcon,
};
export default PersonSeller;
